/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import Address from "./Address";
import BaseCom from "./BaseCom";
import Card from "./Card";
import FormInput from "./FormInput";
import FormLabel from "./FormLabel";
import Icon from "./Icon";
import Auth from "../shared/Auth";
import L from "./Lang";

export default class Person extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            item: props.item || {
                address: {}
            },
            readOnly: false
        };
        if (!this.state.item.address)
            this.state.item.address = {};
        this.genders = [{ id: 'M', name: 'Male' }, { id: 'F', name: 'Female' }, { id: 'U', name: 'Unknown' }];
        this.races = [{ id: 'American Indian or Alaska Native', name: 'American Indian or Alaska Native' },
        { id: 'Asian', name: 'Asian' },
        { id: 'Black or African American', name: 'Black or African American' },
        { id: 'Native Hawaiian or Other Pacific Islander', name: 'Native Hawaiian or Other Pacific Islander' },
        { id: 'White', name: 'White' },
        { id: 'Other Race', name: 'Other Race' }];
        this.ethnicities = [
            { id: 'Hispanic or Latino', name: 'Hispanic or Latino' },
            { id: 'Not Hispanic or Latino', name: 'Not Hispanic or Latino' }
        ];
    }

    componentDidUpdate(prevProps) {
        if (this.props.item !== prevProps.item) {
            this.setState({ item: this.props.item });
        }
        else {
            for (var k in this.props.item) {
                if (this.props.item[k] !== prevProps.item[k])
                    this.setState({ item: this.props.item });
            }
        }
        if (this.props.readOnly !== prevProps.readOnly) {
            this.setState({ readOnly: this.props.readOnly });
        }
    }

    addContact = () => {
        let contacts = null
        if (this.state.item.contacts)
            contacts = [...this.state.item.contacts];
        else
            contacts = [];
        contacts.push({});
        this.setState({ item: { ...this.state.item, contacts: contacts } });
    }

    render() {
        if (this.props.readOnly) {
            return (
                <>
                    <Card title={this.props.title} style={{ overflow: 'visible' }} headerButtons={this.props.orderID && Auth.hasRole('account-manager') ? <Link to={'/order/view/' + this.props.orderID} role="button" className="btn btn-primary"><Icon icon="faHospitalUser" /> <L>View Patient</L></Link> : null}>
                        <div className="row">
                            <div className="col-md">
                                <FormLabel model={this.state.item.firstName} label="First Name" name="firstName" type="text" required={true} />
                            </div>
                            <div className="col-md">
                                <FormLabel model={this.state.item.middleName} label="Middle Name" name="middleName" type="text" required={false} />
                            </div>
                            <div className="col-md">
                                <FormLabel model={this.state.item.lastName} label="Last Name" name="lastName" type="text" required={true} />
                            </div>
                        </div>
                        {this.props.requireOnlyBasic ? '' : (
                            <div className="row">
                                <div className="col-md-4">
                                    <FormLabel model={this.state.item.birthDate} label="Date of Birth" name="birthDate" type="date" required={!this.props.requireOnlyBasic} />
                                </div>
                                <div className="col-md">
                                    <FormLabel model={this.state.item.gender === 'M' ? 'Male' : (this.state.item.gender === 'F' ? 'Female' : 'Unknown')} label="Gender" name="gender" type="select" options={this.genders} required={!this.props.requireOnlyBasic} />
                                </div>
                                <div className="col-md">
                                    <FormLabel model={this.state.item.race} label="Race" name="race" type="select" options={this.races} required={!this.props.requireOnlyBasic} />
                                </div>
                                <div className="col-md">
                                    <FormLabel model={this.state.item.ethnicity} label="Ethnicity" name="ethnicity" type="select" options={this.ethnicities} required={!this.props.requireOnlyBasic} />
                                </div>
                            </div>)}

                    </Card>
                    {this.props.requestContact ? (<>
                        <Card title={this.props.title + ' Primary Contact'}>
                            <div className="row">
                                <div className="col-md">
                                    <FormLabel model={this.state.item.phone} name="phone" label="Phone" type="tel" />
                                </div>
                                <div className="col-md">
                                    <FormLabel model={this.state.item.phoneRel} name="phoneRel" label="Relationship" type="select" />
                                </div>
                                <div className="col-md">
                                    <FormLabel model={this.state.item.email} label="Email" name="email" type="email" />
                                </div>
                            </div>
                        </Card>

                        {this.state.item.contacts?.map((i, idx) => <Card key={idx} title={this.props.title + ' Additional Contact #' + (idx + 1)}>
                            {/*TODO*/}
                        </Card>)}




                    </>) : ''}
                    {this.props.requestAddress ? (<Address title={this.props.title + ' Address'} item={this.state.item.address} required={!this.props.requireOnlyBasic} readOnly={this.props.readOnly} />) : ''}
                </>
            );
        }

        return (
            <>
                <Card title={this.props.title}>
                    <div className="row">
                        <div className="col-md">
                            <FormInput model={this.state.item} label="First Name" name="firstName" type="text" required={true} onChange={this.props.onChange} />
                        </div>
                        <div className="col-md">
                            <FormInput model={this.state.item} label="Middle Name" name="middleName" type="text" required={false} onChange={this.props.onChange} />
                        </div>
                        <div className="col-md">
                            <FormInput model={this.state.item} label="Last Name" name="lastName" type="text" required={true} onChange={this.props.onChange} />
                        </div>
                    </div>
                    {this.props.requireOnlyBasic ? '' : (
                        <div className="row">
                            <div className="col-md-6">
                                <FormInput model={this.state.item} label="Date of Birth" name="birthDate" type="dateselect" required={!this.props.requireOnlyBasic} onChange={this.props.onChange} />
                            </div>
                            <div className="col-md-6">
                                <FormInput model={this.state.item} label="Gender" name="gender" type="select" options={this.genders} required={!this.props.requireOnlyBasic} onChange={this.props.onChange} />
                            </div>
                            <div className="col-md-6">
                                <FormInput model={this.state.item} label="Race" name="race" type="select" options={this.races} required={!this.props.requireOnlyBasic} onChange={this.props.onChange} />
                            </div>
                            <div className="col-md-6">
                                <FormInput model={this.state.item} label="Ethnicity" name="ethnicity" type="select" options={this.ethnicities} required={!this.props.requireOnlyBasic} onChange={this.props.onChange} />
                            </div>
                        </div>)}
                </Card>
                {this.props.requestContact ? (<><Card title={this.props.title + ' Primary Contact'}>
                    <div className="row">
                        <div className="col-md">
                            <FormInput model={this.state.item} name="phone" label="Phone" type="text" onChange={this.props.onChange} />
                        </div>
                        <div className="col-md">
                            <FormInput model={this.state.item} name="phoneRel" label="Relationship" type="select" onChange={this.props.onChange} options={[
                                { id: 'Self', name: 'Self' },
                                { id: 'Spouse', name: 'Spouse' },
                                { id: 'Parent', name: 'Parent' },
                                { id: 'Son', name: 'Son' },
                                { id: 'Daughter', name: 'Daughter' },
                                { id: 'Other', name: 'Other' }
                            ]} />
                        </div>
                        <div className="col-md">
                            <FormInput model={this.state.item} label="Email" name="email" type="email" onChange={this.props.onChange} />
                        </div>
                    </div>
                </Card></>) : ''}


                {this.state.item.contacts?.map((i, idx) => <Card key={idx} title={this.props.title + ' Additional Contact #' + (idx + 1)}>
                    <div className="row">
                        <div className="col-md">
                            <FormInput model={i} name="phone" label="Phone" type="text" onChange={this.props.onChange} />
                        </div>
                        <div className="col-md">
                            <FormInput model={i} name="phoneRel" label="Relationship" type="select" onChange={this.props.onChange} options={[
                                { id: 'Self', name: 'Self' },
                                { id: 'Spouse', name: 'Spouse' },
                                { id: 'Parent', name: 'Parent' },
                                { id: 'Son', name: 'Son' },
                                { id: 'Daughter', name: 'Daughter' },
                                { id: 'Other', name: 'Other' }
                            ]} />
                        </div>
                        <div className="col-md">
                            <FormInput model={i} label="Email" name="email" type="email" onChange={this.props.onChange} />
                        </div>
                    </div>
                </Card>)}

                {false && <div className="mb-3">
                    <button type="button" className="btn btn-secondary" onClick={this.addContact}>
                        <Icon icon="faPlus" /> <L>Add Additional Contact</L>
                    </button>
                </div>}

                {this.props.requestAddress ? (<Address title={this.props.title + ' Address'} item={this.state.item.address} required={!this.props.requireOnlyBasic} onChange={this.props.onChange} />) : ''}
            </>
        )
    }
}